<template>
  <div class="overview">
    <div class="overview__filters">
      <Filters></Filters>
    </div>

    <div class="overview__main">
      <Search></Search>
      <Results></Results>
    </div>
  </div>
</template>

<script>
import Filters from '@/components/Filters'
import Search from '@/components/Search'
import Results from '@/components/Results'

export default {
  name: 'overview',
  components: {
    Filters,
    Search,
    Results,
  },
  created() {
    document.title = this.$t('general.documentTitle')
  },
}
</script>
